import { Component } from '@angular/core';

@Component({
  selector: 'app-catalog-suggestion-attachments',
  templateUrl: './catalog-suggestion-attachments.component.html',
  styleUrls: [ './catalog-suggestion-attachments.component.scss' ],
})
export class CatalogSuggestionAttachmentsComponent {

}
